import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import AnimateEntrance from '../helper/animate';
class FastspindialogueController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		if (this.vc[this.config.holder][this.config.item]) {
			this.item = this.vc[this.config.holder].fsSprite;
			this.item.fs.handler = this.update.bind(this);
			this.item.fs.setActive(GameConfigs.fast_spin);
			this.item.fsText.interactive = true;
			this.item.fsText.buttonMode = true;
			this.item.fsText.cursor = 'pointer';
			this.item.fsText.on(
				window.isMobile || window.isTablet ? 'tap' : 'click',
				this.update.bind(this)
			);
			this.init();
			AnimateEntrance(this.vc);
			window.addEventListener(EVENTS.MODAL, this, false);
			window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
			window.addEventListener(EVENTS.SERVER_MSG, this, false);
		} else {
			throw new Error(
				'FastspindialogueController failed init ' + JSON.stringify(this.config)
			);
		}
	}
	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.MODAL:
				this.removeEvents();
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (evt.detail.data.fast_spin === undefined) return;
				setTimeout(() => {
					this.item.fs.setActive(evt.detail.data.fast_spin);
					this.init();
				}, 10);
				break;
			case EVENTS.SERVER_MSG:
				if (evt.detail.service === 'bet') {
					if (evt.detail.data.bonuswin) {
						this.removeEvents();
					}
				}
				break;
			default:
				break;
		}
	}

	removeEvents() {
		GameConfigs.fastPlayDialogue = true;
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
	}
	init() {
		this.item.fs.bg.alpha = this.item.fs.active ? 1 : 0;
		this.item.fs.fg.alpha = this.item.fs.active ? 0 : 1;
	}
	update() {
		this.item.fs.active = !this.item.fs.active;
		this.init();
		HELPERS.setSettings({
			fast_spin: this.item.fs.active
		});
	}
}

export default FastspindialogueController;
